//imports
import {
  PREFERENCES_GET_PREFERENCES_REQUEST,
  PREFERENCES_GET_PREFERENCES_RESULT,
  PREFERENCES_GET_PREFERENCES_RESULT_UPDATE,
  PREFERENCES_SAVE_PREFERENCE,
  PREFERENCES_UPDATE_PREFERENCES_OTHER,
  PREFERENCES_CLEAR_RETURNED_KEY
} from 'Redux/actionTypes';

export const getPreferences = (entityName, entityId, force) => ({
  type: PREFERENCES_GET_PREFERENCES_REQUEST,
  payload: { entityName, entityId, force }
});

export const getPreferencesResult = (data) => ({
  type: PREFERENCES_GET_PREFERENCES_RESULT,
  payload: data
});

export const savePreference = (entityName, entityId, preferenceKey, preferenceValue) => ({
  type: PREFERENCES_SAVE_PREFERENCE,
  payload: { entityName, entityId, preferenceKey, preferenceValue }
})

export const updatePreferenceView = (value) => ({
  type: PREFERENCES_GET_PREFERENCES_RESULT_UPDATE,
  payload: value
})

export const updatePreferencesOther = (preferencesOther) => ({
  type: PREFERENCES_UPDATE_PREFERENCES_OTHER,
  payload: preferencesOther
})

export const clearReturnedKey = (preferencesKey) => ({
  type: PREFERENCES_CLEAR_RETURNED_KEY,
  payload: { preferencesKey }
})